import React from 'react';
import { Modal } from 'react-bootstrap';
import { LuSparkles } from 'react-icons/lu';
import { HiOutlinePhotograph } from 'react-icons/hi';
import ButtonMain from '../../../../Atoms/ButtonMain';
import ButtonSecondary from '../../../../Atoms/ButtonSecondary';
import './styles.css';

export default function IdeasToConceptsModal({ 
    show, 
    onHide,
    onSaveOnly,
    onGenerateConcepts
}) {
    const handleClose = () => {
        onHide();
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose}
            centered
            backdrop="static"
            className="ideas-to-concepts-modal"
        >
            <Modal.Header closeButton className="ideas-to-concepts-modal-header"/>
            
            <Modal.Body className="ideas-to-concepts-modal-body">
                <h2 className="ideas-to-concepts-modal-title">
                    <div className="ideas-to-concepts-modal-icon">
                        <HiOutlinePhotograph size={50} />
                    </div>
                    Quer transformar ideias em conceitos?
                </h2>
                
                <p className="ideas-to-concepts-modal-subtitle">
                    Gere para cada ideia selecionada:
                </p>
                
                <ul className="ideas-to-concepts-modal-list">
                    <li>Imagem conceitual</li>
                    <li>Como funciona</li>
                    <li>Impacto no negócio</li>
                    <li>Valor para o usuário</li>
                </ul>
            </Modal.Body>
            
            <Modal.Footer className="ideas-to-concepts-modal-footer">
                <ButtonSecondary onClick={onSaveOnly}>
                    Salvar somente as ideias
                </ButtonSecondary>
                
                <ButtonMain onClick={onGenerateConcepts}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <LuSparkles size={18} />
                        Gerar conceitos
                    </span>
                </ButtonMain>
            </Modal.Footer>
        </Modal>
    );
}

